import { jsx as _jsx } from "react/jsx-runtime";
import ReactDOM from 'react-dom';
import './index.css';
import { Footer, } from './components/footer/footer';
import SubFooter from './components/footer/SubFooter/subfooter';
import { Navbar } from './components/Navbar/Navbar';
import { HoverNumberedList } from './components/HoverNumberedList/Index';
import { FullBleedHero } from './components/FullBleedHero/FullBleedHero';
import AnimatedHero from './components/hero/animated';
import CardCarousel from './components/CardCarousel/Index';
import { HeroText } from './components/heroText/HeroText';
import TwoColumnsImageText from './components/TwoColumnsImageText/Index';
import TwoColumnBackgroundShape from './components/LeafMediaCards/Index';
import { TwoCards } from './components/twoCards/Index';
import TwoColumnsHoverTextList from './components/TwoColumnsHoverTextList/Index';
import DirectoryList from './components/directoryList/DirectoryList';
import CenteredHeadline from './components/CenteredHeadline/Index';
import TwoColumnMultipleImage from './components/TwoColumnMultipleImage/TwoColumnMultipleImage';
import TwoColumnsIframe from './components/TwoColumnsIframeImage/Index';
import LogoDisplay from './components/LogoDisplay/Index';
import { ScrollLockedLottieSlider as ScrollLockedSlider } from './components/scrollLockedSlider/ScrollLockedLottieSlider';
import OneColorHero from './components/OneColorHero/OneColorHero';
import CenteredHeadlineCTA from './components/CenteredHeadlineCTA/Index';
import { ScrollLockedImageText } from './components/scrollLockedImageText/ScrollLockedImageText';
import ScrollLockHorizontalReveal from './components/ScrollLockHorizontalReveal/Index';
import LongHeroVideo from './components/LongHeroVideoComponent/Index';
import ArticlePage from './components/Article/index';
import RichText from './components/richText/richText';
import SingleHorizontalCard from './components/SingleHorizontalCard/index';
import HeroWithDiagonalImage from './components/heroWithDiagonalImage/heroWithDiagonalImage';
import ColumnContentCards from './components/columnContentCards/columnContentCards';
import SquareTextHero from './components/SquareTextHero';
import LeadershipGrid from './components/leadershipGrid/leadershipGrid';
import { BrowserRouter } from 'react-router-dom';
import LogoListDisplay from './components/LogoListDisplay/Index';
import HomepageHero from './components/HomepageHero/HomepageHero';
import FullBleedImageVideo from './components/FullBleedImageVideo/FullBleedImageVideo';
import PricingTiers from './components/PricingTiers/index';
import HeadlineCTA from './components/HeadlineCTA/Index';
import ContentCards from './components/Article/ContentCards/index';
import { HoverListWithTabs } from './components/HoverListWithTabs/Index';
import { ShortHero } from './components/ShortHero/ShortHero';
import { TextImageVideo } from './components/TextImageVideo/TextImageVideo';
import Padding from './components/PaddingComponent/Padding';
import OurIntegrationsWithDiagonalImage from './components/OurIntegrationsWithDiagonalImage/OurIntegrationsWithDiagonalImage';
import BlogListDisplay from './components/CardsListPagination/Index';
import FeaturedBlogs from './components/FeaturedBlogs/Index';
import FeaturedTeasers from "./components/FeaturedTeasers/Index";
import BlogLandingHero from './components/BlogLandingHero/BlogLandingHero';
import HeroPressRelease from './components/HeroPressRelease/HeroPressRelease';
import { HoverTextListWithTabs } from './components/HoverTextListWithTabs/Index';
import TwoColumnsImageTextNew from './components/TwoColumnsImageTextNew/Index';
/**
 * Pulling data from data- attribute
 *
 */
if (sessionStorage) {
    var customDrupalDomEvent = new CustomEvent("drupalDomChanged", {
        detail: {
            ready: false,
        },
    });
    sessionStorage.setItem("drupalDomReady", 'false');
    document.dispatchEvent(customDrupalDomEvent);
}
var twoColumnsImageTextArray = document.getElementsByClassName('twocolumnsimagetext-drupal');
renderComponent(TwoColumnsImageText, twoColumnsImageTextArray, 'twocolumnsimagetext');
var headerArray = document.getElementsByClassName('header-drupal');
renderComponent(Navbar, headerArray, 'header');
var footerArray = document.getElementsByClassName('footer-drupal');
renderComponent(Footer, footerArray, 'footer');
var subfooterArray = document.getElementsByClassName('subfooter-drupal');
renderComponent(SubFooter, subfooterArray, 'subfooter');
var animatedheroArray = document.getElementsByClassName('animatedhero-drupal');
renderComponent(AnimatedHero, animatedheroArray, 'animatedhero');
var herotextoArray = document.getElementsByClassName('herotext-drupal');
renderComponent(HeroText, herotextoArray, 'herotext');
var cardcarouselArray = document.getElementsByClassName('cardcarousel-drupal');
renderComponent(CardCarousel, cardcarouselArray, 'cardcarousel');
var twocolumnbackgroundshapeArray = document.getElementsByClassName('twocolumnbackgroundshape-drupal');
renderComponent(TwoColumnBackgroundShape, twocolumnbackgroundshapeArray, 'twocolumnbackgroundshape');
var twocardsArray = document.getElementsByClassName('twocards-drupal');
renderComponent(TwoCards, twocardsArray, 'twocards');
var twocolumnshovertextlistArray = document.getElementsByClassName('twocolumnshovertextlist-drupal');
renderComponent(TwoColumnsHoverTextList, twocolumnshovertextlistArray, 'twocolumnshovertextlist');
var directorylistArray = document.getElementsByClassName('directorylist-drupal');
renderComponent(DirectoryList, directorylistArray, 'directorylist');
var centeredheadlineArray = document.getElementsByClassName('centeredheadline-drupal');
renderComponent(CenteredHeadline, centeredheadlineArray, 'centeredheadline');
var twocoulmnmultipleimageArray = document.getElementsByClassName('twocoulmnmultipleimage-drupal');
renderComponent(TwoColumnMultipleImage, twocoulmnmultipleimageArray, 'twocoulmnmultipleimage');
var logodisplayArray = document.getElementsByClassName('logodisplay-drupal');
renderComponent(LogoDisplay, logodisplayArray, 'logodisplay');
var logolistdisplayArray = document.getElementsByClassName('logolistdisplay-drupal');
renderComponent(LogoListDisplay, logolistdisplayArray, 'logolistdisplay');
var onecolorheroArray = document.getElementsByClassName('onecolorhero-drupal');
renderComponent(OneColorHero, onecolorheroArray, 'onecolorhero');
var twocolumniframeArray = document.getElementsByClassName('twocolumniframe-drupal');
renderComponent(TwoColumnsIframe, twocolumniframeArray, 'twocolumniframe');
var scrolllockedsliderArray = document.getElementsByClassName('scrolllockedslider-drupal');
renderComponent(ScrollLockedSlider, scrolllockedsliderArray, 'scrolllockedslider');
var centeredheadlinectaArray = document.getElementsByClassName('centeredheadlinecta-drupal');
renderComponent(CenteredHeadlineCTA, centeredheadlinectaArray, 'centeredheadlinecta');
var intelligentlifeArray = document.getElementsByClassName('intelligentlife-drupal');
renderComponent(FullBleedHero, intelligentlifeArray, 'intelligentlife');
var scrolllockedimagetextArray = document.getElementsByClassName('scrolllockedimagetext-drupal');
renderComponent(ScrollLockedImageText, scrolllockedimagetextArray, 'scrolllockedimagetext');
var scrolllockedhorizontalrevealArray = document.getElementsByClassName('scrolllockedhorizontalreveal-drupal');
renderComponent(ScrollLockHorizontalReveal, scrolllockedhorizontalrevealArray, 'scrolllockedhorizontalreveal');
var longherovideoArray = document.getElementsByClassName('longherovideo-drupal');
renderComponent(LongHeroVideo, longherovideoArray, 'longherovideo');
var articleArray = document.getElementsByClassName('article-drupal');
renderComponent(ArticlePage, articleArray, 'article');
var richtextArray = document.getElementsByClassName('richtext-drupal');
renderComponent(RichText, richtextArray, 'richtext');
var singlehorizontalcardArray = document.getElementsByClassName('singlehorizontalcard-drupal');
renderComponent(SingleHorizontalCard, singlehorizontalcardArray, 'singlehorizontalcard');
var herowithdiagonalimageArray = document.getElementsByClassName('herowithdiagonalimage-drupal');
renderComponent(HeroWithDiagonalImage, herowithdiagonalimageArray, 'herowithdiagonalimage');
var columncontentcardsArray = document.getElementsByClassName('columncontentcards-drupal');
renderComponent(ColumnContentCards, columncontentcardsArray, 'columncontentcards');
var jobstobedoneArray = document.getElementsByClassName('jobstobedone-drupal');
renderComponent(HoverNumberedList, jobstobedoneArray, 'jobstobedone');
var squaretextHeroArray = document.getElementsByClassName('squaretexthero-drupal');
renderComponent(SquareTextHero, squaretextHeroArray, 'squaretexthero');
var leadershipgridArray = document.getElementsByClassName('leadershipgrid-drupal');
renderComponent(LeadershipGrid, leadershipgridArray, 'leadershipgrid');
var homepageHeroArray = document.getElementsByClassName('homepagehero-drupal');
renderComponent(HomepageHero, homepageHeroArray, 'homepagehero');
var fullBleedImageArray = document.getElementsByClassName('fullbleedimage-drupal');
renderComponent(FullBleedImageVideo, fullBleedImageArray, 'fullbleedimage');
var pricingTiersArray = document.getElementsByClassName('pricingtiers-drupal');
renderComponent(PricingTiers, pricingTiersArray, 'pricingtiers');
var headlineCtaArray = document.getElementsByClassName('headlinecta-drupal');
renderComponent(HeadlineCTA, headlineCtaArray, 'headlinecta');
var ContentCardsArray = document.getElementsByClassName('contentcards-drupal');
renderComponent(ContentCards, ContentCardsArray, 'contentcards');
var shortHeroArray = document.getElementsByClassName('shorthero-drupal');
renderComponent(ShortHero, shortHeroArray, 'shorthero');
var textImageVideoArray = document.getElementsByClassName('textimagevideo-drupal');
renderComponent(TextImageVideo, textImageVideoArray, 'textimagevideo');
var paddingArray = document.getElementsByClassName('paddingcomponent-drupal');
renderComponent(Padding, paddingArray, 'paddingcomponent');
var blogListArray = document.getElementsByClassName('blogListDisplay-drupal');
renderComponent(BlogListDisplay, blogListArray, 'bloglistdisplay');
var ourIntegrationsWithDiagonalImageArray = document.getElementsByClassName('ourintegrationswithdiagonalimage-drupal');
renderComponent(OurIntegrationsWithDiagonalImage, ourIntegrationsWithDiagonalImageArray, 'ourintegrationswithdiagonalimage');
var HoverListTabs = document.getElementsByClassName('hoverlistcategorycarousel-drupal'); //HoverListWithTabs
renderComponent(HoverListWithTabs, HoverListTabs, 'hoverlistcategorycarousel');
var FeaturedBlogsArray = document.getElementsByClassName('featuredblogs-drupal');
renderComponent(FeaturedBlogs, FeaturedBlogsArray, 'featuredblogs');
var FeaturedTeasersArray = document.getElementsByClassName('featuredteasers-drupal');
renderComponent(FeaturedTeasers, FeaturedTeasersArray, 'featuredteasers');
var BlogLandingHeroArray = document.getElementsByClassName('bloglandinghero-drupal');
renderComponent(BlogLandingHero, BlogLandingHeroArray, 'bloglandinghero');
var HeroPressReleaseArray = document.getElementsByClassName('heropressrelease-drupal');
renderComponent(HeroPressRelease, HeroPressReleaseArray, 'heropressrelease');
//HoverTextListWithTabs
var HoverTextListTabs = document.getElementsByClassName('hoverlisttextcategorycarousel-drupal'); //HoverListWithTabs
renderComponent(HoverTextListWithTabs, HoverTextListTabs, 'hoverlisttextcategorycarousel');
//TwoColumnsImageTextNew
var twoColumnsImageTextNewArray = document.getElementsByClassName('twocolumnsimagetextnew-drupal');
renderComponent(TwoColumnsImageTextNew, twoColumnsImageTextNewArray, 'twocolumnsimagetextnew');
/**
 * Mapping DOM elements with React components
 *
 */
function renderComponent(CompName, compArry, dataAttr) {
    for (var _i = 0, compArry_1 = compArry; _i < compArry_1.length; _i++) {
        var element = compArry_1[_i];
        var componentData = JSON.parse((element === null || element === void 0 ? void 0 : element.dataset[dataAttr]) || JSON.stringify({}));
        if (componentData && Object.keys(componentData).length > 0) {
            if (dataAttr === 'leadershipgrid' ||
                dataAttr === 'scrolllockedimagetext' ||
                dataAttr === 'fullbleedimage' ||
                dataAttr === 'bloglandinghero' ||
                dataAttr === 'heropressrelease' ||
                dataAttr === 'logolistdisplay') {
                ReactDOM.render(_jsx(BrowserRouter, { children: _jsx(CompName, { data: componentData }, void 0) }, void 0), element);
            }
            else {
                ReactDOM.render(_jsx(CompName, { data: componentData }, void 0), element);
            }
        }
    }
}
/**
 *
 * Manage dom events
 *
 *
 */
if (sessionStorage) {
    var snapMainContainer = document.getElementById("container-snap-scroller");
    sessionStorage.setItem("drupalDomReady", 'true');
    var customDrupalDomEvent = new CustomEvent("drupalDomChanged", {
        detail: {
            ready: true,
        },
    });
    document.dispatchEvent(customDrupalDomEvent);
    var canWindowKeepInTop = function () {
        var isRouteContainsHash = window.location.hash.length;
        var isCustomScrollPosition = sessionStorage.getItem('customScrollPosition') === 'true';
        return !isRouteContainsHash && !isCustomScrollPosition;
    };
    if (canWindowKeepInTop()) {
        snapMainContainer === null || snapMainContainer === void 0 ? void 0 : snapMainContainer.scroll(0, 0);
    }
}
